export default __webpack_public_path__ + "static/media/upJoystickArrow.1f411d64.svg";